(function () {
      "use strict";

      function trackEvent(name, detail) {
        console.log("[track]", name, detail || {});
        /* TODO: replace with real GA4 / Meta Pixel call before launch */
      }

      var pageParams = new URLSearchParams(window.location.search);

      if (pageParams.get("capture") === "1") {
        document.documentElement.classList.add("capture-mode");
      }

      var previewMoments = {
        "day1-before": "2026-10-14T08:30:00-07:00",
        "day1-lucky": "2026-10-14T09:15:00-07:00",
        "day1-lightning": "2026-10-14T12:30:00-07:00",
        "day1-complete": "2026-10-14T15:00:00-07:00",
        "brand-day-before": "2026-10-15T08:30:00-07:00",
        "brand-day-lucky": "2026-10-15T09:15:00-07:00",
        "brand-day-lightning": "2026-10-15T12:30:00-07:00",
        "brand-day-extra-lightning": "2026-10-15T16:30:00-07:00",
        "brand-day-complete": "2026-10-15T18:30:00-07:00"
      };
      var previewMoment = previewMoments[pageParams.get("kate_day_state")] || null;

      function getCampaignNow() {
        return previewMoment ? new Date(previewMoment) : new Date();
      }

      var EVENT_START = new Date("2026-10-14T00:00:00-07:00");
      var EVENT_END = new Date("2026-10-17T00:00:00-07:00");
      var BAG_WINDOWS = [
        { start: new Date("2026-10-14T09:00:00-07:00"), end: new Date("2026-10-14T10:00:00-07:00"), label: "9:00 AM PT", day: 1 },
        { start: new Date("2026-10-14T10:00:00-07:00"), end: new Date("2026-10-14T11:00:00-07:00"), label: "10:00 AM PT", day: 1 },
        { start: new Date("2026-10-15T09:00:00-07:00"), end: new Date("2026-10-15T10:00:00-07:00"), label: "9:00 AM PT", day: 2 },
        { start: new Date("2026-10-15T10:00:00-07:00"), end: new Date("2026-10-15T11:00:00-07:00"), label: "10:00 AM PT", day: 2 },
        { start: new Date("2026-10-16T09:00:00-07:00"), end: new Date("2026-10-16T10:00:00-07:00"), label: "9:00 AM PT", day: 3 },
        { start: new Date("2026-10-16T10:00:00-07:00"), end: new Date("2026-10-16T11:00:00-07:00"), label: "10:00 AM PT", day: 3 }
      ];
      var FLASH_WINDOWS = [
        { start: new Date("2026-10-14T12:00:00-07:00"), end: new Date("2026-10-14T14:00:00-07:00"), day: 1, label: "12:00 PM PT" },
        { start: new Date("2026-10-15T12:00:00-07:00"), end: new Date("2026-10-15T14:00:00-07:00"), day: 2, label: "12:00 PM PT" },
        { start: new Date("2026-10-15T16:00:00-07:00"), end: new Date("2026-10-15T18:00:00-07:00"), day: 2, label: "4:00 PM PT", extra: true },
        { start: new Date("2026-10-16T12:00:00-07:00"), end: new Date("2026-10-16T14:00:00-07:00"), day: 3, label: "12:00 PM PT" }
      ];
      var pageMain = document.getElementById("main");
      var livePanel = document.getElementById("event-live-panel");
      var eventQuickDock = document.getElementById("event-quick-dock");
      var lastQuickNavLiveKey = null;
      var luckySection = document.getElementById("lucky-bags");
      var lightningSection = document.getElementById("lightning-deals");
      var luckyHome = document.createComment("Lucky Bags original position");
      var lightningHome = document.createComment("Lightning Deals original position");

      if (luckySection && luckySection.parentNode) luckySection.parentNode.insertBefore(luckyHome, luckySection);
      if (lightningSection && lightningSection.parentNode) lightningSection.parentNode.insertBefore(lightningHome, lightningSection);

      function pad(value) {
        return String(Math.max(0, value)).padStart(2, "0");
      }

      function durationParts(milliseconds) {
        var total = Math.max(0, Math.floor(milliseconds / 1000));
        var days = Math.floor(total / 86400);
        var hours = Math.floor((total % 86400) / 3600);
        var minutes = Math.floor((total % 3600) / 60);
        var seconds = total % 60;
        return { days: days, hours: hours, minutes: minutes, seconds: seconds };
      }

      function formatDuration(milliseconds, includeDays) {
        var parts = durationParts(milliseconds);
        if (includeDays && parts.days > 0) {
          return parts.days + "d " + pad(parts.hours) + "h " + pad(parts.minutes) + "m";
        }
        var totalHours = parts.hours + (parts.days * 24);
        return pad(totalHours) + ":" + pad(parts.minutes) + ":" + pad(parts.seconds);
      }

      function getPacificDay(now) {
        var parts = new Intl.DateTimeFormat("en-US", {
          timeZone: "America/Los_Angeles",
          month: "2-digit",
          day: "2-digit"
        }).formatToParts(now);
        var values = {};
        parts.forEach(function (part) { values[part.type] = part.value; });
        if (values.month === "10" && Number(values.day) >= 14 && Number(values.day) <= 16) {
          return Number(values.day) - 13;
        }
        return 1;
      }

      function setStickyState(label, note, href) {
        if (label === "Shop Kate Day →") {
          label = "Get drop alerts →";
          href = "#notify";
        }
        label = label
          .replace("Lightning Deals are live", "Lightning deals are live")
          .replace("Shop Today's Deals", "Shop today's deals")
          .replace("Join the Community", "Join the community")
          .replace("Next Drop", "Next drop");
        document.getElementById("sticky-button").textContent = label;
        document.getElementById("sticky-button").setAttribute("href", href);
        document.getElementById("sticky-note").textContent = note;
      }

      function getLightningCollectionUrl() {
        var cta = document.getElementById("flash-cta");
        return (cta && cta.getAttribute("data-collection-url")) || "https://www.katebackdrop.com/collections/lightning-deals";
      }

      function getLuckyBagProductUrl() {
        var cta = document.getElementById("lucky-shared-cta");
        return (cta && cta.getAttribute("data-product-url")) || "https://www.katebackdrop.com/products/kate-lucky-bag-free-shipping";
      }

      function updateHeroState(now, liveFlash, liveBag) {
        var eyebrow = document.getElementById("hero-eyebrow");
        var subhead = document.getElementById("hero-subhead");
        var cta = document.getElementById("hero-primary-cta");
        var duringEvent = now >= EVENT_START && now < EVENT_END;

        if (liveFlash) {
          eyebrow.textContent = (liveFlash.extra ? "Kate Day Extra Lightning Deals LIVE" : "Lightning Deals LIVE") + " · Day " + liveFlash.day + " of 3";
          subhead.textContent = "Up to 50% off with free shipping. This limited deal window ends in " + formatDuration(liveFlash.end - now, false) + ".";
          cta.textContent = "Shop Lightning Deal Now";
          cta.setAttribute("href", getLightningCollectionUrl());
        } else if (liveBag) {
          eyebrow.textContent = "Lucky Bag LIVE · Day " + liveBag.day + " of 3";
          subhead.textContent = "Today’s surprise Lucky Bag is available now. Quantities are limited and past drops have often sold out within 30 minutes.";
          cta.textContent = "Shop Lucky Bag Now";
          cta.setAttribute("href", getLuckyBagProductUrl());
        } else if (duringEvent) {
          var day = getPacificDay(now);
          eyebrow.textContent = "Happy Kate Day · Day " + day + " of 3";
          subhead.textContent = "25% off regular-price items, double points, and free gifts are active all day. Check the schedule for the next limited drop.";
          cta.textContent = "Shop 25% Off Sitewide";
          cta.setAttribute("href", "#recommendations");
        } else if (now >= EVENT_END) {
          eyebrow.textContent = "Kate Day 2026 · Celebration complete";
          subhead.textContent = "Kate Day has wrapped, but the photographer community keeps creating together all year long.";
          cta.textContent = "Join the Community";
          cta.setAttribute("href", "https://www.facebook.com/groups/katebackdrop");
        } else {
          eyebrow.textContent = "October 14–16 · Pacific Time";
          subhead.textContent = "Three days of surprise Lucky Bags, up to 50% off, and free gifts — whether you’re new to Kate or have celebrated with us before, everyone is welcome.";
          cta.textContent = "Get Sale Alerts";
          cta.setAttribute("href", "#notify");
        }
      }

      function restoreSection(section, marker) {
        if (section && marker.parentNode && marker.nextSibling !== section) {
          marker.parentNode.insertBefore(section, marker.nextSibling);
        }
      }

      function moveSectionAfterLivePanel(section) {
        if (section && livePanel && livePanel.parentNode && livePanel.nextElementSibling !== section) {
          livePanel.parentNode.insertBefore(section, livePanel.nextSibling);
        }
      }

      function suppressConflictingOfferPopup(isLiveWindow) {
        document.documentElement.classList.toggle("kate-day-live-window", isLiveWindow);
        if (!isLiveWindow) return;

        document.querySelectorAll('[role="dialog"], [aria-label="Marketing offer form"]').forEach(function (dialog) {
          var text = dialog.textContent || "";
          if (!/free product|15%\s*off/i.test(text)) return;

          var node = dialog;
          var parent = dialog.parentElement;
          while (parent && parent !== document.body) {
            if (window.getComputedStyle(parent).position === "fixed" || parent.getAttribute("role") === "dialog") node = parent;
            parent = parent.parentElement;
          }
          node.hidden = true;
          node.setAttribute("aria-hidden", "true");
          node.style.setProperty("display", "none", "important");
        });
      }

      function updateLiveExperience(now, liveFlash, liveBag) {
        var isLiveWindow = Boolean(liveFlash || liveBag);
        var currentDay = getPacificDay(now);
        var title = document.getElementById("event-live-title");
        var kicker = document.getElementById("event-live-kicker");
        var meta = document.getElementById("event-live-meta");
        var clock = document.getElementById("event-live-clock");
        var cta = document.getElementById("event-live-cta");

        suppressConflictingOfferPopup(isLiveWindow);
        luckySection && luckySection.classList.toggle("is-live-passive", Boolean(liveFlash));
        lightningSection && lightningSection.classList.toggle("is-live-passive", Boolean(liveBag));
        luckySection && luckySection.classList.toggle("is-live-priority", Boolean(liveBag));
        lightningSection && lightningSection.classList.toggle("is-live-priority", Boolean(liveFlash));

        if (!isLiveWindow || !livePanel) {
          if (livePanel) livePanel.hidden = true;
          restoreSection(luckySection, luckyHome);
          restoreSection(lightningSection, lightningHome);
          return;
        }

        livePanel.hidden = false;
        kicker.textContent = "Kate Day · Day " + currentDay + " of 3";

        if (liveFlash) {
          title.textContent = liveFlash.extra ? "Kate Day extra Lightning Deals are live" : "Lightning Deals are live";
          meta.textContent = "Up to 50% off · Free shipping · Limited quantities";
          clock.textContent = formatDuration(liveFlash.end - now, false);
          cta.textContent = "Shop the Lightning Deal →";
          cta.setAttribute("href", getLightningCollectionUrl());
          restoreSection(luckySection, luckyHome);
          moveSectionAfterLivePanel(lightningSection);
        } else {
          title.textContent = "A Lucky Bag drop is live";
          meta.textContent = "One backdrop · Size and printed design are selected at random";
          clock.textContent = formatDuration(liveBag.end - now, false);
          cta.textContent = "Shop the Lucky Bag →";
          cta.setAttribute("href", getLuckyBagProductUrl());
          restoreSection(lightningSection, lightningHome);
          moveSectionAfterLivePanel(luckySection);
        }
      }

      function updateCampaignState() {
        var now = getCampaignNow();
        var topbar = document.getElementById("topbar-message");
        var topbarLink = document.getElementById("topbar-link");
        var currentDay = getPacificDay(now);
        var liveFlash = FLASH_WINDOWS.find(function (item) { return now >= item.start && now < item.end; });
        var liveBag = BAG_WINDOWS.find(function (item) { return now >= item.start && now < item.end; });
        var nextBagToday = BAG_WINDOWS.find(function (item) { return item.day === currentDay && now < item.start; });

        document.documentElement.classList.toggle("kate-day-event-active", now >= EVENT_START && now < EVENT_END);
        if (eventQuickDock) eventQuickDock.hidden = !(now >= EVENT_START && now < EVENT_END);
        document.querySelectorAll("[data-event-nav-key]").forEach(function (link) {
          var key = link.getAttribute("data-event-nav-key");
          var isLive = (key === "lucky" && Boolean(liveBag)) || (key === "lightning" && Boolean(liveFlash));
          link.classList.toggle("is-live", isLive);
          link.setAttribute("aria-label", link.querySelector("span").textContent + (isLive ? " — live now" : ""));
        });

        var quickNavLiveKey = liveBag ? "lucky" : (liveFlash ? "lightning" : null);
        if (quickNavLiveKey !== lastQuickNavLiveKey) {
          if (quickNavLiveKey) setEventQuickCurrent(quickNavLiveKey);
          else if (lastQuickNavLiveKey) setEventQuickCurrent("sitewide");
          lastQuickNavLiveKey = quickNavLiveKey;
        }

        updateHeroState(now, liveFlash, liveBag);
        updateLiveExperience(now, liveFlash, liveBag);

        topbar.classList.toggle("is-reminder", now < EVENT_START);

        if (now < EVENT_START) {
          topbar.innerHTML = "Kate Day starts <strong>Oct 14</strong> · <strong>3 days only</strong> · <span class=\"topbar-reminder-cta\">Reminder →</span>";
          topbarLink.setAttribute("href", "#calendar-reminder");
          setStickyState("Shop Kate Day →", "Starts in " + formatDuration(EVENT_START - now, true), "#schedule");
        } else if (liveFlash) {
          topbar.textContent = (liveFlash.extra ? "Kate Day Extra Lightning Deals LIVE" : "Lightning Deals LIVE") + " · Ends in " + formatDuration(liveFlash.end - now, false);
          topbarLink.setAttribute("href", getLightningCollectionUrl());
          setStickyState("Lightning Deals are live →", "Ends in " + formatDuration(liveFlash.end - now, false), getLightningCollectionUrl());
        } else if (liveBag) {
          topbar.textContent = "Day " + liveBag.day + " · Lucky Bag LIVE · Ends in " + formatDuration(liveBag.end - now, false);
          topbarLink.setAttribute("href", getLuckyBagProductUrl());
          setStickyState("Lucky Bag is live →", "Closes in " + formatDuration(liveBag.end - now, false), getLuckyBagProductUrl());
        } else if (now < EVENT_END && nextBagToday) {
          topbar.textContent = "Day " + currentDay + " · Next Lucky Bag in " + formatDuration(nextBagToday.start - now, false) + " · " + nextBagToday.label;
          topbarLink.setAttribute("href", "#lucky-bags");
          setStickyState("Next Drop in " + formatDuration(nextBagToday.start - now, false) + " →", nextBagToday.label, getLuckyBagProductUrl());
        } else if (now < EVENT_END) {
          topbar.textContent = "🎉 Happy Kate Day! Day " + currentDay + " of 3 · 25% Off Sitewide + Double Points →";
          topbarLink.setAttribute("href", "#recommendations");
          setStickyState("Shop Today's Deals →", "Day " + currentDay + " of 3 · 25% off + 2X points", "#recommendations");
        } else {
          topbar.textContent = "Kate Day 2026 has wrapped · Join the community for what's next →";
          topbarLink.setAttribute("href", "https://www.facebook.com/groups/katebackdrop");
          setStickyState("Join the Community →", "Kate Day 2026 has wrapped", "https://www.facebook.com/groups/katebackdrop");
        }
      }

      function updateLuckyBagDisplay() {
        var now = getCampaignNow();
        var cards = Array.from(document.querySelectorAll(".bag-card[data-day]"));
        var lanes = Array.from(document.querySelectorAll(".bag-lane"));
        var sharedCta = document.getElementById("lucky-shared-cta");
        var sharedNote = document.getElementById("lucky-shared-note");
        var status = document.getElementById("lucky-status");
        var statusLabel = document.getElementById("lucky-status-label");
        var statusValue = document.getElementById("lucky-status-value");
        var statusNote = document.getElementById("lucky-status-note");
        var beforeEvent = now < EVENT_START;
        var duringEvent = now >= EVENT_START && now < EVENT_END;
        var liveBag = BAG_WINDOWS.find(function (item) { return now >= item.start && now < item.end; });

        function resetLuckyCta(label, note, force) {
          if (!force && sharedCta.hasAttribute("data-selected-code")) return;
          sharedCta.setAttribute("href", getLuckyBagProductUrl());
          sharedCta.removeAttribute("data-selected-code");
          sharedCta.textContent = "Add to cart";
          sharedNote.textContent = note;
        }

        status.hidden = true;
        lanes.forEach(function (lane) { lane.hidden = false; });

        cards.forEach(function (card) {
          var start = new Date(card.getAttribute("data-start"));
          var end = new Date(card.getAttribute("data-end"));
          var action = card.querySelector(".button");
          var codeButton = card.querySelector(".copy-button");
          var isLive = now >= start && now < end;
          card.classList.remove("is-live", "is-ended");
          action.textContent = "Unlock Surprise";
          action.removeAttribute("aria-disabled");
          codeButton.disabled = false;
          codeButton.setAttribute("aria-disabled", "false");
          if (isLive) {
            card.classList.add("is-live");
          } else if (now >= end) {
            card.classList.add("is-ended");
            action.textContent = "Drop Ended";
            action.setAttribute("aria-disabled", "true");
          }
        });

        if (beforeEvent) {
          resetLuckyCta("Shop Lucky Bags →", "Choose a Lucky Bag above and copy its code before opening the product page.");
          cards.forEach(function (card) { card.hidden = false; });
          return;
        }

        if (!duringEvent) {
          resetLuckyCta("Add to cart", "Kate Day Lucky Bag drops have ended.");
          cards.forEach(function (card) { card.hidden = true; });
          lanes.forEach(function (lane) { lane.hidden = true; });
          status.hidden = false;
          statusLabel.textContent = "Lucky Bag Drops";
          statusValue.textContent = "Kate Day 2026 has wrapped.";
          statusNote.textContent = "Join the Kate community to hear what's coming next.";
          return;
        }

        var currentDay = getPacificDay(now);

        if (!liveBag) {
          resetLuckyCta("Shop Lucky Bags →", "Choose a Lucky Bag above and copy its code before opening the product page.");
        } else if (!sharedCta.hasAttribute("data-selected-code")) {
          sharedCta.setAttribute("href", getLuckyBagProductUrl());
          sharedCta.textContent = "Add to cart";
          sharedNote.textContent = "Copy the live card code to apply it when opening the product page.";
        }
        var todayCards = cards.filter(function (card) {
          return Number(card.getAttribute("data-day")) === currentDay;
        });
        var todayFirstStart = Math.min.apply(null, todayCards.map(function (card) {
          return new Date(card.getAttribute("data-start")).getTime();
        }));
        var todayLastEnd = Math.max.apply(null, todayCards.map(function (card) {
          return new Date(card.getAttribute("data-end")).getTime();
        }));
        var betweenEventDays = (currentDay > 1 && now.getTime() < todayFirstStart) || now.getTime() >= todayLastEnd;

        if (betweenEventDays) {
          var nextDrop = BAG_WINDOWS.find(function (item) { return now < item.start; });
          cards.forEach(function (card) { card.hidden = true; });
          lanes.forEach(function (lane) { lane.hidden = true; });
          status.hidden = false;
          if (nextDrop) {
            statusLabel.textContent = "Next Lucky Bag Drop";
            statusValue.textContent = formatDuration(nextDrop.start - now, true);
            statusNote.textContent = "Day " + nextDrop.day + " opens at " + nextDrop.label + ".";
          } else {
            statusLabel.textContent = "Lucky Bag Drops";
            statusValue.textContent = "All drops have ended.";
            statusNote.textContent = "Kate Day offers continue through the end of Day 3.";
          }
          return;
        }

        cards.forEach(function (card) {
          card.hidden = Number(card.getAttribute("data-day")) !== currentDay;
        });
        lanes.forEach(function (lane) {
          lane.hidden = !Array.from(lane.querySelectorAll(".bag-card")).some(function (card) { return !card.hidden; });
        });
      }

      function updateFlashClock() {
        var now = getCampaignNow();
        var live = FLASH_WINDOWS.find(function (item) { return now >= item.start && now < item.end; });
        var next = FLASH_WINDOWS.find(function (item) { return now < item.start; });
        var label = document.getElementById("deal-clock-label");
        var value = document.getElementById("deal-clock-value");
        var cta = document.getElementById("flash-cta");
        var collectionUrl = getLightningCollectionUrl();
        if (live) {
          label.textContent = live.extra ? "Kate Day extra session ends in" : "Ends in";
          value.textContent = formatDuration(live.end - now, false);
          cta.textContent = "Grab the deal";
          cta.setAttribute("href", collectionUrl);
          cta.classList.remove("is-ended");
          cta.removeAttribute("aria-disabled");
        } else if (next) {
          label.textContent = "Day " + next.day + (next.extra ? " extra session" : "") + " starts in";
          value.textContent = formatDuration(next.start - now, true);
          cta.textContent = "Shop Lightning Deals →";
          cta.setAttribute("href", collectionUrl);
          cta.classList.remove("is-ended");
          cta.removeAttribute("aria-disabled");
        } else {
          label.textContent = "Lightning Deals";
          value.textContent = "ENDED";
          cta.textContent = "Shop Lightning Deals →";
          cta.setAttribute("href", collectionUrl);
          cta.classList.remove("is-ended");
          cta.removeAttribute("aria-disabled");
        }
      }

      function renderDealCountdownUnits() {
        var raw = document.getElementById("deal-clock-value").textContent.trim();
        var units = document.getElementById("deal-countdown-units");
        var unitNodes = [
          document.getElementById("deal-countdown-unit-1"),
          document.getElementById("deal-countdown-unit-2"),
          document.getElementById("deal-countdown-unit-3")
        ];
        var values = [
          document.getElementById("deal-count-1"),
          document.getElementById("deal-count-2"),
          document.getElementById("deal-count-3")
        ];
        var labels = [
          document.getElementById("deal-count-label-1"),
          document.getElementById("deal-count-label-2"),
          document.getElementById("deal-count-label-3")
        ];
        var dayFormat = raw.match(/^(\d+)d\s+(\d+)h\s+(\d+)m$/i);
        var liveFormat = raw.match(/^(\d+):(\d+):(\d+)$/);

        units.classList.toggle("is-ended", raw === "ENDED");
        unitNodes.forEach(function (node) { node.hidden = false; });

        if (dayFormat) {
          values[0].textContent = dayFormat[1];
          values[1].textContent = dayFormat[2];
          values[2].textContent = dayFormat[3];
          labels[0].textContent = "Days";
          labels[1].textContent = "Hours";
          labels[2].textContent = "Min";
        } else if (liveFormat) {
          values[0].textContent = liveFormat[1];
          values[1].textContent = liveFormat[2];
          values[2].textContent = liveFormat[3];
          labels[0].textContent = "Hours";
          labels[1].textContent = "Min";
          labels[2].textContent = "Sec";
        } else {
          values[0].textContent = raw || "—";
          labels[0].textContent = "Status";
          unitNodes[1].hidden = true;
          unitNodes[2].hidden = true;
        }
      }

      var dealClockValue = document.getElementById("deal-clock-value");
      var dealClockObserver = new MutationObserver(renderDealCountdownUnits);
      dealClockObserver.observe(dealClockValue, { childList: true, characterData: true, subtree: true });

      function updateNextEventSummary() {
        var now = getCampaignNow();
        var bagDetails = [
          "$19.99 · 1 random-size Backdrop (6.5×6.5 / 10×6.5 / 5×10ft)",
          "$59.99 · Themed Bundle Lucky Bag",
          "$9.99 · 1 random-size Backdrop (7×5 / 8×6ft)",
          "$49.99 · Random Prop or Stand Lucky Bag",
          "$29.99 · 1 random-size Backdrop (8.2×8.2 / 10×8.2 / 10×10ft)",
          "$59.99 · Themed Bundle Lucky Bag"
        ];
        var events = BAG_WINDOWS.map(function (item, index) {
          return { start: item.start, end: item.end, day: item.day, time: item.label, title: bagDetails[index], href: "#lucky-bags", type: "lucky" };
        }).concat(FLASH_WINDOWS.map(function (item) {
          return { start: item.start, end: item.end, day: item.day, time: item.label, title: (item.extra ? "Kate Day Extra Lightning Deals" : "Lightning Deals") + " · Up to 50% off", href: "#lightning-deals", type: "lightning" };
        })).sort(function (a, b) { return a.start - b.start; });

        var live = events.find(function (item) { return now >= item.start && now < item.end; });
        var next = events.find(function (item) { return now < item.start; });
        var target = live || next;
        var kicker = document.getElementById("next-event-kicker");
        var title = document.getElementById("next-event-title");
        var meta = document.getElementById("next-event-meta");
        var link = document.getElementById("next-event-link");

        if (target) {
          kicker.textContent = live ? "Live now" : "Next timed offer";
          title.textContent = target.title;
          meta.textContent = live
            ? "Day " + target.day + " · Ends in " + formatDuration(target.end - now, false)
            : "Starts in " + formatDuration(target.start - now, true) + " · Day " + target.day + " · " + target.time;
          link.textContent = live ? "Shop now" : "View next offer";
          link.setAttribute("href", target.type === "lightning" ? getLightningCollectionUrl() : getLuckyBagProductUrl());
        } else if (now < EVENT_END) {
          kicker.textContent = "Timed drops complete";
          title.textContent = "Today's limited windows have ended.";
          meta.textContent = "25% off sitewide and double Rewards points continue through Day 3.";
          link.textContent = "Shop Kate Day Top Picks";
          link.setAttribute("href", "#recommendations");
        } else {
          kicker.textContent = "Kate Day 2026";
          title.textContent = "The celebration has wrapped.";
          meta.textContent = "Join the community to hear what comes next.";
          link.textContent = "Join the community";
          link.setAttribute("href", "https://www.facebook.com/groups/katebackdrop");
        }
      }

      function selectDay(day) {
        document.querySelectorAll(".tab-button").forEach(function (button) {
          var selected = Number(button.getAttribute("data-day")) === day;
          button.setAttribute("aria-selected", String(selected));
          button.setAttribute("tabindex", selected ? "0" : "-1");
        });
        document.querySelectorAll(".tab-panel").forEach(function (panel) {
          panel.hidden = Number(panel.getAttribute("data-panel-day")) !== day;
        });
      }

      function getScheduleDayEnd(day) {
        var windowsForDay = FLASH_WINDOWS.filter(function (item) { return item.day === day; });
        if (!windowsForDay.length) return EVENT_END;
        return new Date(Math.max.apply(null, windowsForDay.map(function (item) { return item.end.getTime(); })));
      }

      function getDefaultScheduleDay(now) {
        for (var day = 1; day <= 3; day += 1) {
          if (now < getScheduleDayEnd(day)) return day;
        }
        return 3;
      }

      function updateScheduleState(now) {
        document.querySelectorAll(".tab-button[data-day]").forEach(function (button) {
          var day = Number(button.getAttribute("data-day"));
          var ended = now >= getScheduleDayEnd(day);
          button.classList.toggle("is-ended", ended);
          button.setAttribute("aria-label", "Day " + day + (ended ? " — ended" : ""));
        });

        document.querySelectorAll(".tab-panel[data-panel-day]").forEach(function (panel) {
          var day = Number(panel.getAttribute("data-panel-day"));
          var ended = now >= getScheduleDayEnd(day);
          panel.classList.toggle("is-ended", ended);

          panel.querySelectorAll(".timeline-item").forEach(function (item) {
            if (!item.hasAttribute("data-original-href")) item.setAttribute("data-original-href", item.getAttribute("href") || "");
            if (!item.hasAttribute("data-original-label")) item.setAttribute("data-original-label", item.getAttribute("aria-label") || "");
            item.classList.toggle("is-ended", ended);

            if (ended) {
              item.removeAttribute("href");
              item.setAttribute("aria-disabled", "true");
              item.setAttribute("tabindex", "-1");
              item.setAttribute("aria-label", item.getAttribute("data-original-label") + " — ended");
            } else {
              item.setAttribute("href", item.getAttribute("data-original-href"));
              item.removeAttribute("aria-disabled");
              item.removeAttribute("tabindex");
              item.setAttribute("aria-label", item.getAttribute("data-original-label"));
            }
          });
        });
      }

      document.querySelectorAll(".tab-button").forEach(function (button) {
        button.addEventListener("click", function () {
          selectDay(Number(button.getAttribute("data-day")));
        });
        button.addEventListener("keydown", function (event) {
          if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
          var current = Number(button.getAttribute("data-day"));
          var next = event.key === "ArrowRight" ? (current % 3) + 1 : ((current + 1) % 3) + 1;
          selectDay(next);
          document.querySelector('.tab-button[data-day="' + next + '"]').focus();
        });
      });

      var scheduleToggle = document.getElementById("schedule-toggle");
      var scheduleExplorer = document.getElementById("schedule-explorer");
      scheduleToggle.addEventListener("click", function () {
        var expanded = scheduleToggle.getAttribute("aria-expanded") === "true";
        scheduleToggle.setAttribute("aria-expanded", String(!expanded));
        scheduleToggle.firstChild.nodeValue = expanded ? "View full 3-day schedule " : "Hide full 3-day schedule ";
        scheduleExplorer.classList.toggle("is-expanded", !expanded);
      });

      function renderLocalTimes() {
        var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "your local time";
        document.getElementById("timezone-note").textContent = "PT times shown · converted below for " + timezone;
        document.querySelectorAll("[data-local-start]").forEach(function (node) {
          var start = new Date(node.getAttribute("data-local-start"));
          var end = new Date(node.getAttribute("data-local-end"));
          var formatter = new Intl.DateTimeFormat(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
          var endFormatter = new Intl.DateTimeFormat(undefined, { hour: "numeric", minute: "2-digit" });
          node.textContent = "Your time: " + formatter.format(start) + "–" + endFormatter.format(end);
        });
      }

      function copyText(value) {
        if (navigator.clipboard && window.isSecureContext) {
          return navigator.clipboard.writeText(value);
        }
        return new Promise(function (resolve, reject) {
          var field = document.createElement("textarea");
          field.value = value;
          field.setAttribute("readonly", "");
          field.style.position = "fixed";
          field.style.opacity = "0";
          document.body.appendChild(field);
          field.select();
          try {
            if (document.execCommand("copy")) resolve();
            else reject(new Error("Copy unavailable"));
          } catch (error) {
            reject(error);
          }
          document.body.removeChild(field);
        });
      }

      document.querySelectorAll(".copy-button").forEach(function (button) {
        button.addEventListener("click", function () {
          var code = button.getAttribute("data-copy-code");
          var status = button.querySelector(".code-copy-status");
          var selectedCard = button.closest(".bag-card");
          var selectedPrice = selectedCard.querySelector(".bag-price").textContent.trim();
          var selectedProduct = selectedCard.querySelector("h3").textContent.trim();
          var sharedCta = document.getElementById("lucky-shared-cta");
          var sharedNote = document.getElementById("lucky-shared-note");
          trackEvent("discount_code_copy", { code: code });
          copyText(code).then(function () {
            document.querySelectorAll(".copy-button").forEach(function (item) {
              item.classList.remove("is-selected");
              item.setAttribute("aria-pressed", "false");
            });
            document.querySelectorAll(".bag-card").forEach(function (card) {
              card.classList.remove("is-selected");
            });
            button.classList.add("is-copied", "is-selected");
            selectedCard.classList.add("is-selected");
            button.setAttribute("aria-pressed", "true");
            status.textContent = "Copied";
            var productUrl = getLuckyBagProductUrl();
            var productPath = productUrl.replace(/^https?:\/\/[^/]+/i, "");
            sharedCta.setAttribute("href", "https://www.katebackdrop.com/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(productPath));
            sharedCta.setAttribute("data-selected-code", code);
            sharedCta.textContent = "Add to cart";
            sharedNote.textContent = "Code " + code + " copied · It will be applied automatically when you open the product page.";
            setTimeout(function () {
              button.classList.remove("is-copied");
              status.textContent = "Selected";
            }, 1600);
          }).catch(function () {
            status.textContent = "Copy failed";
          });
        });
      });

      document.getElementById("lucky-shared-cta").addEventListener("click", function () {
        var sharedCta = document.getElementById("lucky-shared-cta");
        trackEvent("lucky_bags_shared_cta", {
          code: sharedCta.getAttribute("data-selected-code") || null,
          destination: sharedCta.getAttribute("href")
        });
      });

      var communityModal = document.getElementById("lucky-community-modal");
      var communityModalDialog = communityModal.querySelector(".community-modal-dialog");
      var communityModalTrigger = document.getElementById("community-proof-trigger");
      var communityModalClose = communityModal.querySelector("[data-community-modal-close]");
      var communityModalLastFocus = null;

      function getCommunityModalFocusables() {
        return Array.prototype.slice.call(communityModalDialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
      }

      function openCommunityModal() {
        communityModalLastFocus = document.activeElement;
        communityModal.hidden = false;
        document.body.classList.add("community-modal-open");
        communityModalTrigger.setAttribute("aria-expanded", "true");
        window.requestAnimationFrame(function () {
          communityModalDialog.focus();
        });
        trackEvent("lucky_bag_reveals_open", { source: "lucky_bags" });
      }

      function closeCommunityModal(reason) {
        communityModal.hidden = true;
        document.body.classList.remove("community-modal-open");
        communityModalTrigger.setAttribute("aria-expanded", "false");
        if (communityModalLastFocus && typeof communityModalLastFocus.focus === "function") {
          communityModalLastFocus.focus();
        }
        trackEvent("lucky_bag_reveals_close", { reason: reason || "button" });
      }

      communityModalTrigger.addEventListener("click", openCommunityModal);
      communityModalClose.addEventListener("click", function () {
        closeCommunityModal("button");
      });
      communityModal.querySelector("[data-community-modal-backdrop]").addEventListener("click", function (event) {
        if (event.target === event.currentTarget) closeCommunityModal("backdrop");
      });
      document.addEventListener("keydown", function (event) {
        if (communityModal.hidden) return;
        if (event.key === "Escape") {
          event.preventDefault();
          closeCommunityModal("escape");
          return;
        }
        if (event.key !== "Tab") return;
        var focusables = getCommunityModalFocusables();
        if (!focusables.length) {
          event.preventDefault();
          communityModalDialog.focus();
          return;
        }
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      document.querySelectorAll(".filter-button").forEach(function (button) {
        button.addEventListener("click", function () {
          var filter = button.getAttribute("data-filter");
          document.querySelectorAll(".filter-button").forEach(function (item) {
            item.setAttribute("aria-pressed", String(item === button));
          });
          document.querySelectorAll(".flash-preview").forEach(function (card) {
            card.hidden = filter !== "all" && card.getAttribute("data-category") !== filter;
          });
        });
      });

      document.querySelectorAll("[data-select-filter]").forEach(function (link) {
        link.addEventListener("click", function () {
          var target = link.getAttribute("data-select-filter");
          var button = document.querySelector('.filter-button[data-filter="' + target + '"]');
          if (button) button.click();
        });
      });

      document.querySelectorAll(".faq-question").forEach(function (button) {
        button.addEventListener("click", function () {
          var expanded = button.getAttribute("aria-expanded") === "true";
          var answer = document.getElementById(button.getAttribute("aria-controls"));
          button.setAttribute("aria-expanded", String(!expanded));
          answer.hidden = expanded;
        });
      });

      document.addEventListener("click", function (event) {
        var disabledLink = event.target.closest('a[aria-disabled="true"]');
        if (disabledLink) event.preventDefault();
      });

      var heroSection = document.querySelector(".hero");
      var stickyCta = document.querySelector(".sticky-cta");
      var stickyButton = document.getElementById("sticky-button");

      function setStickyVisibility(isVisible) {
        stickyCta.classList.toggle("is-suppressed", !isVisible);
        stickyCta.setAttribute("aria-hidden", String(!isVisible));
        stickyButton.setAttribute("tabindex", isVisible ? "0" : "-1");
      }

      if ("IntersectionObserver" in window) {
        var heroVisibilityObserver = new IntersectionObserver(function (entries) {
          setStickyVisibility(!entries[0].isIntersecting);
        }, { threshold: 0.05 });
        heroVisibilityObserver.observe(heroSection);
      } else {
        setStickyVisibility(true);
      }

      var eventQuickLinks = Array.from(document.querySelectorAll("[data-event-nav-key]"));
      var quickNavVisibility = new Map();

      function setEventQuickCurrent(key) {
        eventQuickLinks.forEach(function (link) {
          var current = link.getAttribute("data-event-nav-key") === key;
          link.classList.toggle("is-current", current);
          if (current) link.setAttribute("aria-current", "location");
          else link.removeAttribute("aria-current");
        });
      }

      eventQuickLinks.forEach(function (link) {
        link.addEventListener("click", function () {
          setEventQuickCurrent(link.getAttribute("data-event-nav-key"));
        });
      });

      if ("IntersectionObserver" in window && eventQuickLinks.length) {
        var quickNavTargets = [
          { node: document.getElementById("recommendations"), key: "sitewide" },
          { node: document.getElementById("savings"), key: "sitewide" },
          { node: document.getElementById("lucky-bags"), key: "lucky" },
          { node: document.getElementById("lightning-deals"), key: "lightning" }
        ].filter(function (item) { return Boolean(item.node); });

        var quickNavObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            quickNavVisibility.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
          });
          var visibleTarget = quickNavTargets
            .slice()
            .sort(function (a, b) {
              return (quickNavVisibility.get(b.node) || 0) - (quickNavVisibility.get(a.node) || 0);
            })[0];
          if (visibleTarget && (quickNavVisibility.get(visibleTarget.node) || 0) > 0) {
            setEventQuickCurrent(visibleTarget.key);
          }
        }, { rootMargin: "-28% 0px -52% 0px", threshold: [0, 0.1, 0.25, 0.5] });

        quickNavTargets.forEach(function (item) {
          quickNavVisibility.set(item.node, 0);
          quickNavObserver.observe(item.node);
        });
      }

      var notifyForm = document.getElementById("notify-form");
      if (notifyForm) {
        notifyForm.addEventListener("submit", function () {
          trackEvent("notify_submit", { source: "never_miss_a_drop" });
        });
      }

      document.getElementById("hero-primary-cta").addEventListener("click", function (event) {
        trackEvent("hero_primary_cta", { destination: event.currentTarget.getAttribute("href") });
      });

      document.getElementById("hero-secondary-cta").addEventListener("click", function (event) {
        trackEvent("hero_secondary_cta", { destination: event.currentTarget.getAttribute("href") });
      });

      document.querySelectorAll("[data-core-offer]").forEach(function (link) {
        link.addEventListener("click", function () {
          trackEvent("core_offer_click:" + link.getAttribute("data-core-offer"), {
            destination: link.getAttribute("href")
          });
        });
      });

      document.querySelectorAll("[data-discount-code]").forEach(function (link) {
        link.addEventListener("click", function () {
          trackEvent("unlock_surprise_click", {
            code: link.getAttribute("data-discount-code"),
            day: link.closest(".bag-card").getAttribute("data-day"),
            destination: link.getAttribute("href")
          });
        });
      });

      document.querySelectorAll('a[href*="/collections/"], a[href*="/products/"]').forEach(function (link) {
        if (link.hasAttribute("data-discount-code")) return;
        link.addEventListener("click", function () {
          trackEvent("product_collection_click", {
            label: link.textContent.trim(),
            destination: link.getAttribute("href")
          });
        });
      });

      var storiesTrack = document.getElementById("customer-stories-track");
      if (storiesTrack) {
        document.querySelectorAll("[data-story-scroll]").forEach(function (button) {
          button.addEventListener("click", function () {
            var direction = Number(button.getAttribute("data-story-scroll")) || 1;
            var card = storiesTrack.querySelector(".polaroid");
            var distance = card ? card.getBoundingClientRect().width + 18 : storiesTrack.clientWidth * 0.8;
            storiesTrack.scrollBy({ left: direction * distance, behavior: "smooth" });
          });
        });
      }

      var initialCampaignNow = getCampaignNow();
      updateScheduleState(initialCampaignNow);
      selectDay(getDefaultScheduleDay(initialCampaignNow));
      renderLocalTimes();
      updateCampaignState();
      updateLuckyBagDisplay();
      updateFlashClock();
      renderDealCountdownUnits();
      updateNextEventSummary();
      setInterval(function () {
        updateCampaignState();
        updateLuckyBagDisplay();
        updateFlashClock();
        updateNextEventSummary();
        updateScheduleState(getCampaignNow());
      }, 1000);
    }());

    // Measure the rendered stack without changing the sizing variables that create it.
    (function () {
      var nodes = [
        [document.querySelector('.topbar'), '--kd-topbar-rendered-h'],
        [document.querySelector('.site-header'), '--kd-header-rendered-h'],
        [document.getElementById('event-quick-dock'), '--kd-dock-rendered-h']
      ];
      function updateStickyHeights() {
        nodes.forEach(function (entry) {
          if (entry[0]) {
            document.documentElement.style.setProperty(entry[1], entry[0].getBoundingClientRect().height + 'px');
          }
        });
      }
      if (window.ResizeObserver) {
        var observer = new ResizeObserver(updateStickyHeights);
        nodes.forEach(function (entry) { if (entry[0]) observer.observe(entry[0]); });
      }
      window.addEventListener('resize', updateStickyHeights);
      updateStickyHeights();
    }());
